import React, { createContext, useContext } from 'react';
import { getCustomerVariables } from './CustomerContextHelper';
import { CustomerVariables } from '../../customerVariables/variable_interfaces';

interface CustomerVariablesContextType {
    customerVariables: CustomerVariables;
    theme: Theme;
}

interface Theme {
    mobileMenuBreakpoint: number;
    mobileTableBreakPoint: number;
    brandColor1: string;
    brandColor2: string;
}

interface CustomerContextProviderProps {
    children: React.ReactNode;
}

const CustomerContext = createContext<CustomerVariablesContextType | undefined>(undefined);

export const CustomerContextProvider: React.FC<CustomerContextProviderProps> = ({ children }) => {
    const customerConfigKey = (process.env.REACT_APP_CUSTOMER_CONFIG || 'default').trim();

    // Dynamically import the theme and customer configuration based on the environment variable
    const themeModule: { [key: string]: Theme } = require(`../../styles/theme/${customerConfigKey}_theme`);
    const theme = themeModule[`${customerConfigKey}Theme`];
    const customerVariables = getCustomerVariables();

    return (
        <CustomerContext.Provider value={{ customerVariables, theme }}>
            {children}
        </CustomerContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(CustomerContext);
    if (!context) {
        throw new Error('useTheme must be used within a CustomerContextProvider');
    }
    return context.theme;
};

export const useVariables = () => {
    const context = useContext(CustomerContext);
    if (!context) {
        throw new Error('useVariables must be used within a CustomerContextProvider');
    }
    return context.customerVariables;
}
